import React, { Component } from 'react';
import { Modal, AutoComplete, Select, Input, message, Spin } from 'antd';
import CascaderCity from '../../common/CascaderCity';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

const { Option } = Select;
const { TextArea } = Input;
const hospitalLevelOptions = ['三级甲等', '三级乙等', '三级丙等', '二级甲等', '二级乙等', '二级丙等', '一级甲等', '一级乙等', '一级丙等', '其他'];

class UpdateHospital extends Component {
    state = {
        params: {},
        visible: false,
        loading: false,
        hospitalList: [],
        degreeOptions: [],
        rejectReasonOptions: [],
        generalNameInput: '',
    }

    show = (record) => {
        const { cityId, provinceId, centerPharmacy, generalNames } = record || {};
        const params = {
            ...(record || {}),
            cityId: cityId ? [provinceId, cityId] : [],
            centerPharmacy: String(centerPharmacy),
            generalNames: generalNames ? (typeof generalNames === 'string' ? generalNames.split(',').filter(Boolean) : generalNames) : [],
        };
        this.setState({
            params,
            visible: true,
            isEdit: !!record,
        });
        // 加载合作程度选项
        this.loadDegreeOptions();
        if (record && record.cooperationDegreeId) {
            this.loadRejectReasonOptions(record.cooperationDegreeId);
        }
    }

    loadDegreeOptions = () => {
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.queryHospitalConfigureList,
            data: { type: 'COOPERATION_DEGREE' },
            dataType: 'json',
            doneResult: res => {
                const list = res.list || [];
                this.setState({ degreeOptions: list });
            }
        });
    }

    loadRejectReasonOptions = (degreeId) => {
        if (!degreeId) {
            this.setState({ rejectReasonOptions: [] });
            return;
        }
        $.sendRequest({
            method: 'POST',
            url: API_URL.hospital.queryHospitalConfigureList,
            data: { type: 'CAUSES_NON_COOPERATION' },
            dataType: 'json',
            doneResult: res => {
                const allList = res.list || [];
                // 根据parentId过滤
                const filtered = allList.filter(item => item.parentId === degreeId);
                this.setState({ rejectReasonOptions: filtered });
            }
        });
    }

    hide = () => {
        this.setState({
            visible: false,
            hospitalList: [],
            degreeOptions: [],
            rejectReasonOptions: [],
            generalNameInput: '',
        });
    }

    submit = () => {
        const {
            isEdit,
            params: {
                hospitalId,
                hospitalName,
                hospitalLevel,
                centerPharmacy,
                cityId,
                hospitalProvince,
                hospitalCity,
                hospitalAddress,
                departmentName,
                postCode,
                remark,
                cooperationDegreeId,
                cooperationRejectReasonId,
                cooperationRejectReason,
                cooperationDegreeComments,
                courtyardArea,
                hospitalCounty,
                generalNames,
            },
        } = this.state;
        if (!hospitalName) {
            message.warning('请输入医院官方名称');
            return;
        }
        if (!hospitalLevel) {
            message.warning('请选择医院等级');
            return;
        }
        if (!centerPharmacy) {
            message.warning('请选择有无中心药房');
            return;
        }
        if (!hospitalProvince || !hospitalCity) {
            message.warning('请选择省市');
            return;
        }
        if (!hospitalAddress) {
            message.warning('请输入详细地址');
            return;
        }

        // 判断选中项是否需要显示不合作原因分类
        const selectedDegree = this.state.degreeOptions.find(d => d.hospitalConfigureId === cooperationDegreeId);
        const needRejectReason = selectedDegree && (selectedDegree.typeCode === 'NOT_UNDERTAKE' || selectedDegree.typeCode === 'SOME_DEPT_UNCOOPERATIVE');
        if (needRejectReason && !cooperationRejectReasonId) {
            message.warning('请选择不合作原因分类');
            return;
        }
        if (needRejectReason && !cooperationRejectReason) {
            message.warning('请输入不合作原因说明');
            return;
        }

        const [ provinceId, hospitalCityId ] = cityId;
        let newParams = {
            hospitalName,
            hospitalId,
            hospitalLevel,
            cityId: hospitalCityId,
            hospitalProvince,
            provinceId,
            hospitalCity,
            hospitalAddress,
            departmentName,
            postCode,
            remark,
            cooperationDegreeId: cooperationDegreeId || '',
            cooperationRejectReasonId: cooperationRejectReasonId || '',
            cooperationRejectReason: cooperationRejectReason || '',
            cooperationDegreeComments,
            courtyardArea,
            hospitalCounty,
            centerPharmacy,
            generalNames: (generalNames || []).join(','),
        };
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.hospital.modifyHospital,
            data: newParams,
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({
                    loading: false,
                }, () => {
                    this.hide();
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleInputChange = (e, key) => {
        const { params } = this.state;
        params[key] = e.target.value;
        this.setState({ params });
    }

    handleSelectChange = (value, key) => {
        const { params } = this.state;
        if (key == 'cooperationDegreeId') {
            params.cooperationRejectReasonId = null;
            params.cooperationRejectReason = '';
            this.loadRejectReasonOptions(value);
        }
        params[key] = value;
        this.setState({ params });
    }

    handleCascaderCityChange = (value, selectedOptions, key) => {
        const { params } = this.state;
        const [{ label: hospitalProvince } = { label: '' }, { label: hospitalCity } = { label: '' }] = selectedOptions;
        params[key] = value;
        params.hospitalProvince = hospitalProvince;
        params.hospitalCity = hospitalCity;
        this.setState({ params });
    }

    // 医院曾用名称 - 添加
    addGeneralName = () => {
        const { params, generalNameInput } = this.state;
        const name = generalNameInput.trim();
        if (!name) {
            message.warning('请输入医院曾用名称');
            return;
        }
        const names = params.generalNames || [];
        if (names.length >= 3) {
            message.warning('最多添加三个曾用名');
            return;
        }
        if (names.includes(name)) {
            message.warning('该名称已存在');
            return;
        }
        names.push(name);
        params.generalNames = names;
        this.setState({ params, generalNameInput: '' });
    }

    // 医院曾用名称 - 删除
    removeGeneralName = (index) => {
        const { params } = this.state;
        const names = params.generalNames || [];
        names.splice(index, 1);
        params.generalNames = names;
        this.setState({ params });
    }

    // 医院曾用名称 - 输入框变化
    handleGeneralNameInputChange = (e) => {
        this.setState({ generalNameInput: e.target.value });
    }

    // 医院曾用名称 - 回车添加
    handleGeneralNameKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.addGeneralName();
        }
    }

    getSelectedDegreeTypeCode = () => {
        const { params, degreeOptions } = this.state;
        const selected = degreeOptions.find(d => d.hospitalConfigureId === params.cooperationDegreeId);
        return selected ? selected.typeCode : null;
    }

    getContent = () => {
        const { params, visible, hospitalList, degreeOptions, rejectReasonOptions, generalNameInput } = this.state;
        const {
            hospitalName,
            hospitalLevel,
            hospitalAddress,
            postCode,
            centerPharmacy,
            hospitalProvince,
            hospitalCity,
            remark,
            cooperationDegreeId,
            cooperationRejectReasonId,
            cooperationRejectReason,
            cooperationDegreeComments,
            courtyardArea,
            hospitalCounty,
            generalNames,
        } = params;
        const asterisk = <span style={{ color: 'red' }}>*</span>;
        const hospitalOptions = hospitalList.map(i => <Option key={i.hospitalId} disabled>{i.hospitalName}</Option>);
        const selectedTypeCode = this.getSelectedDegreeTypeCode();
        const showRejectReasonSelect = selectedTypeCode === 'NOT_UNDERTAKE' || selectedTypeCode === 'SOME_DEPT_UNCOOPERATIVE';
        return (
            <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left">{asterisk}医院官方名称:</div>
                    <div className="item-right">
                        {
                            visible &&
                            <Input
                                maxLength='120'
                                value={hospitalName}
                                style={{ width: 180 }}
                                onChange={e => this.handleInputChange(e, 'hospitalName')}
                            />
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">院区:</div>
                    <div className="item-right">
                        <Input
                                disabled={!hospitalName}
                                maxLength='120'
                                value={courtyardArea}
                                style={{ width: 180 }}
                                onChange={e => this.handleInputChange(e, 'courtyardArea')}
                            />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">医院曾用名称:</div>
                    <div className="item-right">
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Input
                                maxLength='120'
                                value={generalNameInput}
                                style={{ width: 160 }}
                                placeholder="请输入"
                                onChange={this.handleGeneralNameInputChange}
                                onKeyDown={this.handleGeneralNameKeyDown}
                            />
                            <span
                                style={{ marginLeft: 4, cursor: 'pointer', fontSize: 18, fontWeight: 'bold', color: '#1890ff', userSelect: 'none' }}
                                onClick={this.addGeneralName}
                            >+</span>
                        </div>
                        {generalNames && generalNames.length > 0 && (
                            <div style={{ marginTop: 4 }}>
                                {generalNames.map((name, index) => (
                                    <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 2 }}>
                                        <span style={{ marginRight: 4 }}>{name}</span>
                                        <span
                                            style={{ cursor: 'pointer', color: '#ff4d4f', fontWeight: 'bold', userSelect: 'none' }}
                                            onClick={() => this.removeGeneralName(index)}
                                        >-</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}医院等级:</div>
                    <div className="item-right">
                        <Input
                                disabled={true}
                                maxLength='120'
                                value={hospitalLevel || undefined}
                                style={{ width: 180 }}
                            />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}省市县级行政区:</div>
                    <div className="item-right">
                        {
                            visible &&
                            <Input
                                disabled={true}
                                maxLength='120'
                                value={hospitalProvince+'/'+hospitalCity+'/'+hospitalCounty}
                                style={{ width: 180 }}
                            />
                        }
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}详细地址:</div>
                    <div className="item-right">
                        <Input
                            disabled={true}
                            maxLength='200'
                            value={hospitalAddress}
                            style={{ width: 180 }}
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'hospitalAddress')}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">邮编:</div>
                    <div className="item-right">
                        <Input
                            maxLength='200'
                            value={postCode}
                            style={{ width: 180 }}
                            placeholder="请输入"
                            onChange={e => this.handleInputChange(e, 'postCode')}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">{asterisk}有无中心药房:</div>
                    <div className="item-right">
                        <Select
                            style={{ width: 180 }}
                            value={centerPharmacy}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'centerPharmacy')}
                        >
                            <Option value="true">有</Option>
                            <Option value="false">无</Option>
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">与津石合作程度:</div>
                    <div className="item-right">
                        <Select
                            style={{ width: 182 }}
                            value={cooperationDegreeId || undefined}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'cooperationDegreeId')}
                        >
                            {
                                degreeOptions.map(i => <Option key={i.hospitalConfigureId} value={i.hospitalConfigureId}>{i.typeValue}</Option>)
                            }
                        </Select>
                    </div>
                </li>
                { showRejectReasonSelect && <li className="modal-item">
                    <div className="item-left">{asterisk}不合作原因分类:</div>
                    <div className="item-right">
                        <Select
                            style={{ width: 182 }}
                            value={cooperationRejectReasonId || undefined}
                            placeholder="请选择"
                            onChange={value => this.handleSelectChange(value, 'cooperationRejectReasonId')}
                        >
                            {
                                rejectReasonOptions.map(i => <Option key={i.hospitalConfigureId} value={i.hospitalConfigureId}>{i.typeValue}</Option>)
                            }
                        </Select>
                    </div>
                </li>}
                { showRejectReasonSelect && <li className="modal-item">
                    <div className="item-left">{asterisk}不合作原因说明:</div>
                    <div className="item-right">
                        <TextArea
                            maxLength='200'
                            placeholder="请输入"
                            value={cooperationRejectReason}
                            style={{ width: 180, height: 80 }}
                            onChange={e => this.handleInputChange(e, 'cooperationRejectReason')}
                        />
                    </div>
                </li>}
                <li className="modal-item">
                    <div className="item-left">合作程度备注:</div>
                    <div className="item-right">
                        <TextArea
                            maxLength='200'
                            placeholder="请输入"
                            value={cooperationDegreeComments}
                            style={{width: 180, height: 80}}
                            onChange={e => this.handleInputChange(e, 'cooperationDegreeComments')}
                        />
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left">备注:</div>
                    <div className="item-right">
                        <TextArea
                            maxLength='200'
                            value={remark}
                            placeholder="请输入"
                            style={{width: 180, height: 80}}
                            onChange={e => this.handleInputChange(e, 'remark')}
                        />
                    </div>
                </li>
            </ul>
        )
    }

    render() {
        const { isEdit, visible, loading } = this.state;
        return (
            <Modal
                title={`${isEdit ? '修改' : '添加'}医院`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                confirmLoading={loading}
                maskClosable={false}
                width="480px"
            >
                 <Spin spinning={loading}>
                    <div className="modal-content" style={{ padding: '0 20px' }}>
                        {this.getContent()}
                    </div>
                </Spin>
            </Modal>
        )
    }
}

export default UpdateHospital;


// WEBPACK FOOTER //
// ./src/components/hospital/hospitalInfo/UpdateHospital.js